import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers, faFile, faFileCircleXmark} from '@fortawesome/free-solid-svg-icons'
import { dashboardStatsCardCount } from "../services/ApiServices";
import { toast } from "react-toastify";

const Dashboard = () => {
    const [ statsCardCount, setStatsCardCount ] = useState()
    const getDashboardStatsCardCount = async () => {
        try{
            const getTotalStatsCardCount = await dashboardStatsCardCount();
            if(getTotalStatsCardCount.status === 200) {
                setStatsCardCount(getTotalStatsCardCount?.data?.data)
            }
        } catch(error) {
            toast.error('Something Wrong')
        }
    }
    useEffect(() => {
        getDashboardStatsCardCount()
    }, [])

    return(
        <React.Fragment>
            <div className="aside-heading">
                <h3>DASHBOARD</h3>
            </div>
            <div className="dashboard-stats">
                <div className="stats-card">
                    <div className="stats-card-text">
                        <h3>Active Users</h3>
                        <p>{statsCardCount?.userActiveCount}</p>
                    </div>
                    <div className="stats-card-icon">
                    <FontAwesomeIcon icon={faUsers} />
                    </div>                    
                </div>
                <div className="stats-card">
                    <div className="stats-card-text">
                        <h3>In-Active Users</h3>
                        <p>{statsCardCount?.userInActiveCount}</p>
                    </div>
                    <div className="stats-card-icon">
                    <FontAwesomeIcon icon={faUsers} />
                    </div>                    
                </div>
                <div className="stats-card">
                <div className="stats-card-text">
                    <h3>Media Posts</h3>
                    <p>{statsCardCount?.mediaPostCount}</p>
                </div>
                <div className="stats-card-icon">
                <FontAwesomeIcon icon={faFile} /></div> 
                </div>
                <div className="stats-card">
                <div className="stats-card-text">
                    <h3>Reported Posts</h3>
                    <p>{statsCardCount?.reportedMediaPostCount}</p>
                </div>
                <div className="stats-card-icon">
                <FontAwesomeIcon icon={faFileCircleXmark} />
                    </div> 
                </div>
            </div>
        </React.Fragment>
    )
};
export default Dashboard;